module.exports = __webpack_public_path__ + "static/media/Slide4.682a101e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide4.webp
// module id = 577
// module chunks = 4